
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserAnswerSlvIVO } from '@/views/biz/omr/vo/Omr.vo'

import { SettingsOmrVO } from '@/components/vo/Settings.vo'
import axios from 'axios'
import CommonUtils from '@/common-utils'
import Constants from '@/constants'

@Component
export default class ReportDialog extends Vue {
  @Prop() emNo !: string
  @Prop() userAnswers !: Array<UserAnswerSlvIVO>
  @Prop() isReport !: boolean;

  // 정답률
  correctAnswerPctg: any = 0;
  // 정답
  correctAnswer = [] as Array<UserAnswerSlvIVO>;
  // 오답
  wrongAnswer = [] as Array<UserAnswerSlvIVO>;
  // 모름
  unknownAnswer = [] as Array<UserAnswerSlvIVO>;
  // 환경설정
  settings: SettingsOmrVO = {} as SettingsOmrVO;

  save(): void {
    this.closeReportDialog();
    this.$emit('update:isReport', true);
  }

  closeReportDialog() {
    this.$store.dispatch(`report/closeModal`, {name: 'report'});
  }

  // ESC 누를 경우 강제로 저장 루틴
  escKeyDownEventHandler() {
    this.save();
  }

  @Watch('$store.state.report.opened')
  calculate(e) {
    if(e == false) return;

    this.wrongAnswer = this.userAnswers.filter(v => v.uaStatus == '0');
    this.correctAnswer = this.userAnswers.filter(v => v.uaStatus == '1');
    this.unknownAnswer = this.userAnswers.filter(v => v.uaStatus == '2');
    console.log(this.userAnswers)

    this.correctAnswerPctg = ((this.correctAnswer.length / this.userAnswers.length)*100).toFixed(2);
  }

  created() {
    this.settings = CommonUtils.getLocalStorageObject(Constants.SETTINGS_OMR);
  }
  
}
